import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from "./i18n";
import VTooltip from "v-tooltip";

import VueMeta from "vue-meta";
import vClickOutside from "v-click-outside";
// import { VueReCaptcha } from "vue-recaptcha-v3";
import VueCarousel from "vue-carousel";
import VueToast from "vue-toast-notification";
// import 'vue-toast-notification/dist/theme-default.css'
import "vue-toast-notification/dist/theme-sugar.css";
import Paginate from "vuejs-paginate";
import VueSocialSharing from "vue-social-sharing";
import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";
import VueCurrencyInput from "vue-currency-input";
import vSelect from "vue-select";
import Vue2Editor from "vue2-editor";
import VueGtag from "vue-gtag";

Vue.use(Vue2Editor);
Vue.component("v-select", vSelect);
Vue.use(VueCurrencyInput);
Vue.component("datetime", Datetime);
Vue.use(VueSocialSharing);
Vue.use(require("vue-moment"));
Vue.component("paginate", Paginate);
Vue.use(VueToast);
Vue.use(VueCarousel);
// Vue.use(VueReCaptcha, {
//   siteKey: "6LeS46sZAAAAAHZlQoplCzNt23BknIeIXJrLfvBr"
// });
Vue.use(vClickOutside);
Vue.use(VueMeta);
Vue.use(VTooltip);

Vue.config.productionTip = false;

const mixin = {
  methods: {}
};

Vue.mixin(mixin);

Vue.use(
  VueGtag,
  {
    config: { id: "G-SR4WFZ58LJ" }
  },
  router
);

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
